import { Component, OnInit, Input, ViewChild, Output, EventEmitter } from '@angular/core';
import { Document } from 'src/app/_models/document';
import { MatTableDataSource } from '@angular/material/table';
import { MatSort } from '@angular/material/sort';
import { MatPaginator } from '@angular/material/paginator';
import { SelectionModel } from '@angular/cdk/collections';
import { DocumentService } from 'src/app/_services/document.services';
import { Category, User } from 'src/app/_models';
import { AuthenticationService } from 'src/app/_services/authentication.service';
import { MatDialog } from '@angular/material/dialog';
import { DialogCaptureUploadComponent } from './dialog-capture-upload/dialog-capture-upload.component';
import { CategoryService } from 'src/app/_services/category.service';
import { AppConfig } from 'src/assets/config/config/app-config';
import { FolderViewComponent } from './folder-view/folder-view.component';

@Component({
  selector: 'app-myfiles',
  templateUrl: './myfiles.component.html',
  styleUrls: ['./myfiles.component.scss']
})
export class MyfilesComponent implements OnInit {

  captureDocsList: any[];
  currentPage = 1;
  itemsPerPage = 5;
  docsList: MatTableDataSource<any>;
  documentCols: String[] = ["select", "srNum", "file_name", "create_date", "created_by"];
  selectedRow: Array<JSON> = [];
  rowSelection: Boolean = false;
  documentId: String;
  documentDetails: Document;
  hideDocList: Boolean = false;
  docLength: number;
  selection = new SelectionModel<any>(true, []);
  owner: any
  groupList: string[]
  activateAssign: boolean = false
  docId: any[]
  categories: Category[];
  currentUser: User;
  assigned: boolean = false
  noDocuments: boolean = false
  selectedDocuments = []
  isMetaData: boolean = false;
  category: Category;
  isBatchCategorization: boolean = false
  categoryID: any;
  searchCtrl: string = "";
  indexedSuccess: boolean = false;
  properties = {};
  indexedDocument = []
  filterInput: string = ""
  internalGroupIdentifiers: string[]
  usersList:string[]=[]
  @Input() filesList: any[];
  @Output() reload = new EventEmitter<boolean>();

  @ViewChild(FolderViewComponent, { static: true }) 
  folderViewComponent: FolderViewComponent;

  sort;
  @ViewChild(MatSort, { static: false }) set content(content: any) {
    this.sort = content;
    if (this.sort) {
      this.docsList.sort = this.sort;
    }
  }

  paginator;
  @ViewChild(MatPaginator, { static: false }) set pageContent(content: any) {
    this.paginator = content;
    if (this.paginator) {
      this.docsList.paginator = this.paginator;
    }
  }

  constructor(
    private categoryService: CategoryService,
    public dialog: MatDialog,
    private authenticationService: AuthenticationService,
    private documentService: DocumentService,
    private appConfig: AppConfig
  ) {
    this.currentUser = this.authenticationService.currentUserValue;
    this.groupList = this.authenticationService.userGroupsValue;
    this.internalGroupIdentifiers = this.appConfig.getInternalGroupsIdentifier()
    if (!this.authenticationService.isAdminValue) {
      if (this.internalGroupIdentifiers) {
        this.internalGroupIdentifiers.forEach(internalGroupIdentifier => {
          this.groupList.forEach((group) => {
            if (group.includes(internalGroupIdentifier)) {
              this.groupList = this.groupList.filter(obj => obj !== group);
            }
          })
        });
      }
    }
  }

  ngOnInit(): void {
    this.getDocuments();

  }

  ngOnChanges() {
    this.getDocuments();
  }

  fetchMetaDataProperties(id) {
    this.isMetaData = true
    this.categoryService.get(id).subscribe(details => {
      this.category = details;
      //console.log("DETAILS",this.category['meta_data_definition']['properties'])
    })
  }

  assignCategory() {
    this.isBatchCategorization = true
    this.selectedDocuments = this.selection.selected
  }

  getDocuments() {

    if (this.filesList && this.filesList.length <= 0) {
      this.noDocuments = true;
    } 

    if (this.filesList) {
      this.docLength = this.filesList.length;
      this.docsList = new MatTableDataSource(this.filesList);
      this.docsList.sort = this.sort;
      this.docsList.paginator = this.paginator;
    }
  }

  uploadCaptureDocument() {
    let dialogRef = this.dialog.open(DialogCaptureUploadComponent,
      { width: '100%', height: "80%" });
    dialogRef.afterClosed().subscribe(result => {
      if (result == true) {
        //this.getGroups();
        this.reload.emit(true);
        this.noDocuments=false;
      }
    });
  }

  isAllSelected() {
    const numSelected = this.selection.selected.length;
    const numRows = this.docsList.data.length;
    return numSelected === numRows;
  }

  refresh() {
    this.folderViewComponent.refresh();
  }

  assign(group) {
    this.docId = []
    this.owner = group;
    this.selection.selected.forEach(ele => {
      this.docId.push(ele.document_id)
    })
    var request = {
      docId: this.docId,
      owner: group
    }

    this.documentService.assignOwner(request).subscribe(res => {
      this.reload.emit(true);
      this.assigned = true
      this.docId = []
    })
  }

  back() {
    this.assigned = false
    this.isBatchCategorization = false
    this.indexedSuccess = false
    this.selection.clear()
  }

  checkboxLabel(row?: any): string {
    //this.docIdArray = true
    if (!row) {
      return `${this.isAllSelected() ? 'select' : 'deselect'} all`;
    }
    return `${this.selection.isSelected(row) ? 'deselect' : 'select'} row 
    ${row.position + 1}`;
  }

  applyFilter() {
    let filterText = this.filterInput.trim().toLowerCase();
    // if (this.docsList.paginator) {
    //   this.docsList.paginator.firstPage();
    // }
    this.folderViewComponent.applyFilter(filterText);
  }

  clearFilter() {
    this.filterInput = ""
    this.docsList.filter = this.filterInput.trim().toLowerCase();
    if (this.docsList.paginator) {
      this.docsList.paginator.firstPage();
    }
  }

  getDocDetails(event, doc) {
    this.rowSelection = true;
    this.documentDetails = doc;
    this.hideDocList = true;
  }

  onHideDocList(hide: boolean) {
    if (hide) {
      this.hideDocList = true;
    } else {
      this.hideDocList = false;
      this.filterInput = ""
      this.reload.emit(true);
    }
  }

  onbatchCategorization(hide: boolean) {
    if (hide) {
      this.isBatchCategorization = true;
    } else {
      this.isBatchCategorization = false;
      this.selection.clear();
      this.reload.emit(true);
    }
  }

}
